import type { ReactNode } from 'react';

import styles from './detail-card.module.scss';

export function DetailCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className={styles.card}>
      <h2 className={styles.title}>{title}</h2>
      <dl className={styles.rows}>{children}</dl>
    </section>
  );
}

export function DetailRow({
  label,
  value,
  muted = false,
}: {
  label: string;
  value: ReactNode;
  /** A disabled field's row: its label fades (Figma 2704:588862). */
  muted?: boolean;
}) {
  return (
    <div className={muted ? `${styles.row} ${styles.muted}` : styles.row}>
      <dt className={styles.label}>{label}</dt>
      <dd className={styles.value}>{value}</dd>
    </div>
  );
}
